import React from 'react';

import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';

import LoginDlgLogo from '../../../../assets/svg/login-dlg-logo.svg';
import { meState } from '../../../../state/panel-state';
import styles from './styles.scss';

function UserWaitRoles({ visible }) {
  const me = useRecoilValue(meState);

  return (
    <>
      <Modal
        className={styles.kybLoginDlg}
        title={null}
        width={610}
        open={visible}
        closable={false}
        footer={null}
      >
        <h1>
          Регистрация в сервисах <LoginDlgLogo />
        </h1>
        <div className={styles.info}>
          Ваш статус: <span>Авторизован</span>
        </div>
        <div className={styles.info}>
          Мобильный: <span>{me.phone}</span>
        </div>

        <div className={styles.msgRed}>
          Ваш аккаунт ожидает настройку доступа модераторами сервиса
        </div>

        <div className={styles.msg}>
          Как только модераторы сервиса настроят доступ для вашего аккаунта, вы получите уведомление
          на указанный при регистрации адрес электронной почты.
        </div>
        <div className={styles.msg}>
          При возникновении вопросов с настройкой доступа, свяжитесь с модераторами KYB.
        </div>
      </Modal>
    </>
  );
}

UserWaitRoles.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default UserWaitRoles;
